/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onReportResult = /* GraphQL */ `
  subscription OnReportResult($id: ID!) {
    onReportResult(id: $id) {
      id
      status
      statusCode
      statusDescription
      location
      __typename
    }
  }
`;
export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser($filter: ModelSubscriptionUserFilterInput) {
    onCreateUser(filter: $filter) {
      id
      name
      customerId
      status
      type
      lastLogin
      clientName
      updateDriverQualifications
      StandardDocuments {
        items {
          id
          for
          forName
          category
          type
          customerId
          driverId
          documentName
          accountMasterCode
          createdAt
          updatedAt
          userStandardDocumentsId
          __typename
        }
        nextToken
        __typename
      }
      Audit {
        items {
          id
          event
          eventTime
          objectName
          objectId
          objectData
          createdAt
          updatedAt
          userAuditId
          __typename
        }
        nextToken
        __typename
      }
      appAccess {
        items {
          id
          createdAt
          updatedAt
          userAppAccessId
          applicationUserAppAccessId
          applicationRoleUserAppAccessId
          __typename
        }
        nextToken
        __typename
      }
      cellPhone
      passwordChangeDate
      preferredMFA
      lastResetMFA
      customersAddedByAmc
      customers {
        items {
          id
          customerId
          active
          createdAt
          updatedAt
          userCustomersId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser($filter: ModelSubscriptionUserFilterInput) {
    onUpdateUser(filter: $filter) {
      id
      name
      customerId
      status
      type
      lastLogin
      clientName
      updateDriverQualifications
      StandardDocuments {
        items {
          id
          for
          forName
          category
          type
          customerId
          driverId
          documentName
          accountMasterCode
          createdAt
          updatedAt
          userStandardDocumentsId
          __typename
        }
        nextToken
        __typename
      }
      Audit {
        items {
          id
          event
          eventTime
          objectName
          objectId
          objectData
          createdAt
          updatedAt
          userAuditId
          __typename
        }
        nextToken
        __typename
      }
      appAccess {
        items {
          id
          createdAt
          updatedAt
          userAppAccessId
          applicationUserAppAccessId
          applicationRoleUserAppAccessId
          __typename
        }
        nextToken
        __typename
      }
      cellPhone
      passwordChangeDate
      preferredMFA
      lastResetMFA
      customersAddedByAmc
      customers {
        items {
          id
          customerId
          active
          createdAt
          updatedAt
          userCustomersId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUser = /* GraphQL */ `
  subscription OnDeleteUser($filter: ModelSubscriptionUserFilterInput) {
    onDeleteUser(filter: $filter) {
      id
      name
      customerId
      status
      type
      lastLogin
      clientName
      updateDriverQualifications
      StandardDocuments {
        items {
          id
          for
          forName
          category
          type
          customerId
          driverId
          documentName
          accountMasterCode
          createdAt
          updatedAt
          userStandardDocumentsId
          __typename
        }
        nextToken
        __typename
      }
      Audit {
        items {
          id
          event
          eventTime
          objectName
          objectId
          objectData
          createdAt
          updatedAt
          userAuditId
          __typename
        }
        nextToken
        __typename
      }
      appAccess {
        items {
          id
          createdAt
          updatedAt
          userAppAccessId
          applicationUserAppAccessId
          applicationRoleUserAppAccessId
          __typename
        }
        nextToken
        __typename
      }
      cellPhone
      passwordChangeDate
      preferredMFA
      lastResetMFA
      customersAddedByAmc
      customers {
        items {
          id
          customerId
          active
          createdAt
          updatedAt
          userCustomersId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateUserCustomer = /* GraphQL */ `
  subscription OnCreateUserCustomer(
    $filter: ModelSubscriptionUserCustomerFilterInput
  ) {
    onCreateUserCustomer(filter: $filter) {
      id
      customerId
      active
      createdAt
      updatedAt
      userCustomersId
      __typename
    }
  }
`;
export const onUpdateUserCustomer = /* GraphQL */ `
  subscription OnUpdateUserCustomer(
    $filter: ModelSubscriptionUserCustomerFilterInput
  ) {
    onUpdateUserCustomer(filter: $filter) {
      id
      customerId
      active
      createdAt
      updatedAt
      userCustomersId
      __typename
    }
  }
`;
export const onDeleteUserCustomer = /* GraphQL */ `
  subscription OnDeleteUserCustomer(
    $filter: ModelSubscriptionUserCustomerFilterInput
  ) {
    onDeleteUserCustomer(filter: $filter) {
      id
      customerId
      active
      createdAt
      updatedAt
      userCustomersId
      __typename
    }
  }
`;
export const onCreateDriverQualification = /* GraphQL */ `
  subscription OnCreateDriverQualification(
    $filter: ModelSubscriptionDriverQualificationFilterInput
  ) {
    onCreateDriverQualification(filter: $filter) {
      id
      tier
      customerId
      name
      driverId
      driverName
      status
      jobId
      jobStartDate
      createEmail
      updateUser
      dqSpecialistUser
      dqSpecialistEmail
      createUserFullName
      dqOwnerFullName
      dqClientApproverUser
      dqClientApproverUserFullName
      dqDocumentName
      questions {
        items {
          id
          user
          text
          createUserFullName
          type
          status
          createdAt
          updatedAt
          driverQualificationQuestionsId
          __typename
        }
        nextToken
        __typename
      }
      driverQualificationServiceTeamNotes {
        items {
          id
          user
          text
          createUserFullName
          createdAt
          updatedAt
          driverQualificationDriverQualificationServiceTeamNotesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      tierDescription
      branch
      driverSkillSummary
      locationState {
        id
        name
        city {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      locationCity {
        id
        state {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        name
        status
        createdAt
        updatedAt
        stateCityId
        __typename
      }
      driverQualificationChecklistDocuments {
        items {
          id
          item
          source
          category
          type
          order
          documentName
          createdAt
          updatedAt
          driverQualificationDriverQualificationChecklistDocumentsId
          __typename
        }
        nextToken
        __typename
      }
      accountMasterCode
      checkListLevel
      fileType
      clientVisible
      updatedAt
      driverQualificationLocationStateId
      driverQualificationLocationCityId
      __typename
    }
  }
`;
export const onUpdateDriverQualification = /* GraphQL */ `
  subscription OnUpdateDriverQualification(
    $filter: ModelSubscriptionDriverQualificationFilterInput
  ) {
    onUpdateDriverQualification(filter: $filter) {
      id
      tier
      customerId
      name
      driverId
      driverName
      status
      jobId
      jobStartDate
      createEmail
      updateUser
      dqSpecialistUser
      dqSpecialistEmail
      createUserFullName
      dqOwnerFullName
      dqClientApproverUser
      dqClientApproverUserFullName
      dqDocumentName
      questions {
        items {
          id
          user
          text
          createUserFullName
          type
          status
          createdAt
          updatedAt
          driverQualificationQuestionsId
          __typename
        }
        nextToken
        __typename
      }
      driverQualificationServiceTeamNotes {
        items {
          id
          user
          text
          createUserFullName
          createdAt
          updatedAt
          driverQualificationDriverQualificationServiceTeamNotesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      tierDescription
      branch
      driverSkillSummary
      locationState {
        id
        name
        city {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      locationCity {
        id
        state {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        name
        status
        createdAt
        updatedAt
        stateCityId
        __typename
      }
      driverQualificationChecklistDocuments {
        items {
          id
          item
          source
          category
          type
          order
          documentName
          createdAt
          updatedAt
          driverQualificationDriverQualificationChecklistDocumentsId
          __typename
        }
        nextToken
        __typename
      }
      accountMasterCode
      checkListLevel
      fileType
      clientVisible
      updatedAt
      driverQualificationLocationStateId
      driverQualificationLocationCityId
      __typename
    }
  }
`;
export const onDeleteDriverQualification = /* GraphQL */ `
  subscription OnDeleteDriverQualification(
    $filter: ModelSubscriptionDriverQualificationFilterInput
  ) {
    onDeleteDriverQualification(filter: $filter) {
      id
      tier
      customerId
      name
      driverId
      driverName
      status
      jobId
      jobStartDate
      createEmail
      updateUser
      dqSpecialistUser
      dqSpecialistEmail
      createUserFullName
      dqOwnerFullName
      dqClientApproverUser
      dqClientApproverUserFullName
      dqDocumentName
      questions {
        items {
          id
          user
          text
          createUserFullName
          type
          status
          createdAt
          updatedAt
          driverQualificationQuestionsId
          __typename
        }
        nextToken
        __typename
      }
      driverQualificationServiceTeamNotes {
        items {
          id
          user
          text
          createUserFullName
          createdAt
          updatedAt
          driverQualificationDriverQualificationServiceTeamNotesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      tierDescription
      branch
      driverSkillSummary
      locationState {
        id
        name
        city {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      locationCity {
        id
        state {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        name
        status
        createdAt
        updatedAt
        stateCityId
        __typename
      }
      driverQualificationChecklistDocuments {
        items {
          id
          item
          source
          category
          type
          order
          documentName
          createdAt
          updatedAt
          driverQualificationDriverQualificationChecklistDocumentsId
          __typename
        }
        nextToken
        __typename
      }
      accountMasterCode
      checkListLevel
      fileType
      clientVisible
      updatedAt
      driverQualificationLocationStateId
      driverQualificationLocationCityId
      __typename
    }
  }
`;
export const onCreateDriverQualificationChecklistDocuments = /* GraphQL */ `
  subscription OnCreateDriverQualificationChecklistDocuments(
    $filter: ModelSubscriptionDriverQualificationChecklistDocumentsFilterInput
  ) {
    onCreateDriverQualificationChecklistDocuments(filter: $filter) {
      id
      item
      source
      category
      type
      order
      documentName
      driverQualificationSelectedDocuments {
        items {
          id
          item
          source
          category
          type
          pages
          order
          documentName
          for
          customerId
          driverId
          documentAutoSelected
          createdAt
          updatedAt
          driverQualificationChecklistDocumentsDriverQualificationSelectedDocumentsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      driverQualificationDriverQualificationChecklistDocumentsId
      __typename
    }
  }
`;
export const onUpdateDriverQualificationChecklistDocuments = /* GraphQL */ `
  subscription OnUpdateDriverQualificationChecklistDocuments(
    $filter: ModelSubscriptionDriverQualificationChecklistDocumentsFilterInput
  ) {
    onUpdateDriverQualificationChecklistDocuments(filter: $filter) {
      id
      item
      source
      category
      type
      order
      documentName
      driverQualificationSelectedDocuments {
        items {
          id
          item
          source
          category
          type
          pages
          order
          documentName
          for
          customerId
          driverId
          documentAutoSelected
          createdAt
          updatedAt
          driverQualificationChecklistDocumentsDriverQualificationSelectedDocumentsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      driverQualificationDriverQualificationChecklistDocumentsId
      __typename
    }
  }
`;
export const onDeleteDriverQualificationChecklistDocuments = /* GraphQL */ `
  subscription OnDeleteDriverQualificationChecklistDocuments(
    $filter: ModelSubscriptionDriverQualificationChecklistDocumentsFilterInput
  ) {
    onDeleteDriverQualificationChecklistDocuments(filter: $filter) {
      id
      item
      source
      category
      type
      order
      documentName
      driverQualificationSelectedDocuments {
        items {
          id
          item
          source
          category
          type
          pages
          order
          documentName
          for
          customerId
          driverId
          documentAutoSelected
          createdAt
          updatedAt
          driverQualificationChecklistDocumentsDriverQualificationSelectedDocumentsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      driverQualificationDriverQualificationChecklistDocumentsId
      __typename
    }
  }
`;
export const onCreateDriverQualificationSelectedDocuments = /* GraphQL */ `
  subscription OnCreateDriverQualificationSelectedDocuments(
    $filter: ModelSubscriptionDriverQualificationSelectedDocumentsFilterInput
  ) {
    onCreateDriverQualificationSelectedDocuments(filter: $filter) {
      id
      item
      source
      category
      type
      pages
      order
      documentName
      for
      customerId
      driverId
      documentAutoSelected
      createdAt
      updatedAt
      driverQualificationChecklistDocumentsDriverQualificationSelectedDocumentsId
      __typename
    }
  }
`;
export const onUpdateDriverQualificationSelectedDocuments = /* GraphQL */ `
  subscription OnUpdateDriverQualificationSelectedDocuments(
    $filter: ModelSubscriptionDriverQualificationSelectedDocumentsFilterInput
  ) {
    onUpdateDriverQualificationSelectedDocuments(filter: $filter) {
      id
      item
      source
      category
      type
      pages
      order
      documentName
      for
      customerId
      driverId
      documentAutoSelected
      createdAt
      updatedAt
      driverQualificationChecklistDocumentsDriverQualificationSelectedDocumentsId
      __typename
    }
  }
`;
export const onDeleteDriverQualificationSelectedDocuments = /* GraphQL */ `
  subscription OnDeleteDriverQualificationSelectedDocuments(
    $filter: ModelSubscriptionDriverQualificationSelectedDocumentsFilterInput
  ) {
    onDeleteDriverQualificationSelectedDocuments(filter: $filter) {
      id
      item
      source
      category
      type
      pages
      order
      documentName
      for
      customerId
      driverId
      documentAutoSelected
      createdAt
      updatedAt
      driverQualificationChecklistDocumentsDriverQualificationSelectedDocumentsId
      __typename
    }
  }
`;
export const onCreateAtsDriverDocuments = /* GraphQL */ `
  subscription OnCreateAtsDriverDocuments(
    $filter: ModelSubscriptionAtsDriverDocumentsFilterInput
  ) {
    onCreateAtsDriverDocuments(filter: $filter) {
      id
      atsDriverId
      category
      documentName
      driverId
      source
      type
      expirationDate
      atsDateCreated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAtsDriverDocuments = /* GraphQL */ `
  subscription OnUpdateAtsDriverDocuments(
    $filter: ModelSubscriptionAtsDriverDocumentsFilterInput
  ) {
    onUpdateAtsDriverDocuments(filter: $filter) {
      id
      atsDriverId
      category
      documentName
      driverId
      source
      type
      expirationDate
      atsDateCreated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAtsDriverDocuments = /* GraphQL */ `
  subscription OnDeleteAtsDriverDocuments(
    $filter: ModelSubscriptionAtsDriverDocumentsFilterInput
  ) {
    onDeleteAtsDriverDocuments(filter: $filter) {
      id
      atsDriverId
      category
      documentName
      driverId
      source
      type
      expirationDate
      atsDateCreated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateStandardDocuments = /* GraphQL */ `
  subscription OnCreateStandardDocuments(
    $filter: ModelSubscriptionStandardDocumentsFilterInput
  ) {
    onCreateStandardDocuments(filter: $filter) {
      id
      for
      forName
      category
      type
      customerId
      driverId
      documentName
      accountMasterCode
      createdAt
      updatedAt
      userStandardDocumentsId
      __typename
    }
  }
`;
export const onUpdateStandardDocuments = /* GraphQL */ `
  subscription OnUpdateStandardDocuments(
    $filter: ModelSubscriptionStandardDocumentsFilterInput
  ) {
    onUpdateStandardDocuments(filter: $filter) {
      id
      for
      forName
      category
      type
      customerId
      driverId
      documentName
      accountMasterCode
      createdAt
      updatedAt
      userStandardDocumentsId
      __typename
    }
  }
`;
export const onDeleteStandardDocuments = /* GraphQL */ `
  subscription OnDeleteStandardDocuments(
    $filter: ModelSubscriptionStandardDocumentsFilterInput
  ) {
    onDeleteStandardDocuments(filter: $filter) {
      id
      for
      forName
      category
      type
      customerId
      driverId
      documentName
      accountMasterCode
      createdAt
      updatedAt
      userStandardDocumentsId
      __typename
    }
  }
`;
export const onCreateQuestions = /* GraphQL */ `
  subscription OnCreateQuestions(
    $filter: ModelSubscriptionQuestionsFilterInput
  ) {
    onCreateQuestions(filter: $filter) {
      id
      user
      text
      createUserFullName
      type
      driverQualification {
        id
        tier
        customerId
        name
        driverId
        driverName
        status
        jobId
        jobStartDate
        createEmail
        updateUser
        dqSpecialistUser
        dqSpecialistEmail
        createUserFullName
        dqOwnerFullName
        dqClientApproverUser
        dqClientApproverUserFullName
        dqDocumentName
        questions {
          nextToken
          __typename
        }
        driverQualificationServiceTeamNotes {
          nextToken
          __typename
        }
        createdAt
        tierDescription
        branch
        driverSkillSummary
        locationState {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        locationCity {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        driverQualificationChecklistDocuments {
          nextToken
          __typename
        }
        accountMasterCode
        checkListLevel
        fileType
        clientVisible
        updatedAt
        driverQualificationLocationStateId
        driverQualificationLocationCityId
        __typename
      }
      status
      createdAt
      updatedAt
      driverQualificationQuestionsId
      __typename
    }
  }
`;
export const onUpdateQuestions = /* GraphQL */ `
  subscription OnUpdateQuestions(
    $filter: ModelSubscriptionQuestionsFilterInput
  ) {
    onUpdateQuestions(filter: $filter) {
      id
      user
      text
      createUserFullName
      type
      driverQualification {
        id
        tier
        customerId
        name
        driverId
        driverName
        status
        jobId
        jobStartDate
        createEmail
        updateUser
        dqSpecialistUser
        dqSpecialistEmail
        createUserFullName
        dqOwnerFullName
        dqClientApproverUser
        dqClientApproverUserFullName
        dqDocumentName
        questions {
          nextToken
          __typename
        }
        driverQualificationServiceTeamNotes {
          nextToken
          __typename
        }
        createdAt
        tierDescription
        branch
        driverSkillSummary
        locationState {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        locationCity {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        driverQualificationChecklistDocuments {
          nextToken
          __typename
        }
        accountMasterCode
        checkListLevel
        fileType
        clientVisible
        updatedAt
        driverQualificationLocationStateId
        driverQualificationLocationCityId
        __typename
      }
      status
      createdAt
      updatedAt
      driverQualificationQuestionsId
      __typename
    }
  }
`;
export const onDeleteQuestions = /* GraphQL */ `
  subscription OnDeleteQuestions(
    $filter: ModelSubscriptionQuestionsFilterInput
  ) {
    onDeleteQuestions(filter: $filter) {
      id
      user
      text
      createUserFullName
      type
      driverQualification {
        id
        tier
        customerId
        name
        driverId
        driverName
        status
        jobId
        jobStartDate
        createEmail
        updateUser
        dqSpecialistUser
        dqSpecialistEmail
        createUserFullName
        dqOwnerFullName
        dqClientApproverUser
        dqClientApproverUserFullName
        dqDocumentName
        questions {
          nextToken
          __typename
        }
        driverQualificationServiceTeamNotes {
          nextToken
          __typename
        }
        createdAt
        tierDescription
        branch
        driverSkillSummary
        locationState {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        locationCity {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        driverQualificationChecklistDocuments {
          nextToken
          __typename
        }
        accountMasterCode
        checkListLevel
        fileType
        clientVisible
        updatedAt
        driverQualificationLocationStateId
        driverQualificationLocationCityId
        __typename
      }
      status
      createdAt
      updatedAt
      driverQualificationQuestionsId
      __typename
    }
  }
`;
export const onCreateDriverQualificationServiceTeamNotes = /* GraphQL */ `
  subscription OnCreateDriverQualificationServiceTeamNotes(
    $filter: ModelSubscriptionDriverQualificationServiceTeamNotesFilterInput
  ) {
    onCreateDriverQualificationServiceTeamNotes(filter: $filter) {
      id
      user
      text
      createUserFullName
      driverQualification {
        id
        tier
        customerId
        name
        driverId
        driverName
        status
        jobId
        jobStartDate
        createEmail
        updateUser
        dqSpecialistUser
        dqSpecialistEmail
        createUserFullName
        dqOwnerFullName
        dqClientApproverUser
        dqClientApproverUserFullName
        dqDocumentName
        questions {
          nextToken
          __typename
        }
        driverQualificationServiceTeamNotes {
          nextToken
          __typename
        }
        createdAt
        tierDescription
        branch
        driverSkillSummary
        locationState {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        locationCity {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        driverQualificationChecklistDocuments {
          nextToken
          __typename
        }
        accountMasterCode
        checkListLevel
        fileType
        clientVisible
        updatedAt
        driverQualificationLocationStateId
        driverQualificationLocationCityId
        __typename
      }
      createdAt
      updatedAt
      driverQualificationDriverQualificationServiceTeamNotesId
      __typename
    }
  }
`;
export const onUpdateDriverQualificationServiceTeamNotes = /* GraphQL */ `
  subscription OnUpdateDriverQualificationServiceTeamNotes(
    $filter: ModelSubscriptionDriverQualificationServiceTeamNotesFilterInput
  ) {
    onUpdateDriverQualificationServiceTeamNotes(filter: $filter) {
      id
      user
      text
      createUserFullName
      driverQualification {
        id
        tier
        customerId
        name
        driverId
        driverName
        status
        jobId
        jobStartDate
        createEmail
        updateUser
        dqSpecialistUser
        dqSpecialistEmail
        createUserFullName
        dqOwnerFullName
        dqClientApproverUser
        dqClientApproverUserFullName
        dqDocumentName
        questions {
          nextToken
          __typename
        }
        driverQualificationServiceTeamNotes {
          nextToken
          __typename
        }
        createdAt
        tierDescription
        branch
        driverSkillSummary
        locationState {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        locationCity {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        driverQualificationChecklistDocuments {
          nextToken
          __typename
        }
        accountMasterCode
        checkListLevel
        fileType
        clientVisible
        updatedAt
        driverQualificationLocationStateId
        driverQualificationLocationCityId
        __typename
      }
      createdAt
      updatedAt
      driverQualificationDriverQualificationServiceTeamNotesId
      __typename
    }
  }
`;
export const onDeleteDriverQualificationServiceTeamNotes = /* GraphQL */ `
  subscription OnDeleteDriverQualificationServiceTeamNotes(
    $filter: ModelSubscriptionDriverQualificationServiceTeamNotesFilterInput
  ) {
    onDeleteDriverQualificationServiceTeamNotes(filter: $filter) {
      id
      user
      text
      createUserFullName
      driverQualification {
        id
        tier
        customerId
        name
        driverId
        driverName
        status
        jobId
        jobStartDate
        createEmail
        updateUser
        dqSpecialistUser
        dqSpecialistEmail
        createUserFullName
        dqOwnerFullName
        dqClientApproverUser
        dqClientApproverUserFullName
        dqDocumentName
        questions {
          nextToken
          __typename
        }
        driverQualificationServiceTeamNotes {
          nextToken
          __typename
        }
        createdAt
        tierDescription
        branch
        driverSkillSummary
        locationState {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        locationCity {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        driverQualificationChecklistDocuments {
          nextToken
          __typename
        }
        accountMasterCode
        checkListLevel
        fileType
        clientVisible
        updatedAt
        driverQualificationLocationStateId
        driverQualificationLocationCityId
        __typename
      }
      createdAt
      updatedAt
      driverQualificationDriverQualificationServiceTeamNotesId
      __typename
    }
  }
`;
export const onCreateDriverQualificationAdditionalDocuments = /* GraphQL */ `
  subscription OnCreateDriverQualificationAdditionalDocuments(
    $filter: ModelSubscriptionDriverQualificationAdditionalDocumentsFilterInput
  ) {
    onCreateDriverQualificationAdditionalDocuments(filter: $filter) {
      id
      driverQualificationAdditionalDocumentsId
      documentName
      originalFileName
      uploadedByEmail
      uploadedByFullName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDriverQualificationAdditionalDocuments = /* GraphQL */ `
  subscription OnUpdateDriverQualificationAdditionalDocuments(
    $filter: ModelSubscriptionDriverQualificationAdditionalDocumentsFilterInput
  ) {
    onUpdateDriverQualificationAdditionalDocuments(filter: $filter) {
      id
      driverQualificationAdditionalDocumentsId
      documentName
      originalFileName
      uploadedByEmail
      uploadedByFullName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDriverQualificationAdditionalDocuments = /* GraphQL */ `
  subscription OnDeleteDriverQualificationAdditionalDocuments(
    $filter: ModelSubscriptionDriverQualificationAdditionalDocumentsFilterInput
  ) {
    onDeleteDriverQualificationAdditionalDocuments(filter: $filter) {
      id
      driverQualificationAdditionalDocumentsId
      documentName
      originalFileName
      uploadedByEmail
      uploadedByFullName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateAudit = /* GraphQL */ `
  subscription OnCreateAudit($filter: ModelSubscriptionAuditFilterInput) {
    onCreateAudit(filter: $filter) {
      id
      event
      eventTime
      user {
        id
        name
        customerId
        status
        type
        lastLogin
        clientName
        updateDriverQualifications
        StandardDocuments {
          nextToken
          __typename
        }
        Audit {
          nextToken
          __typename
        }
        appAccess {
          nextToken
          __typename
        }
        cellPhone
        passwordChangeDate
        preferredMFA
        lastResetMFA
        customersAddedByAmc
        customers {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      objectName
      objectId
      objectData
      createdAt
      updatedAt
      userAuditId
      __typename
    }
  }
`;
export const onUpdateAudit = /* GraphQL */ `
  subscription OnUpdateAudit($filter: ModelSubscriptionAuditFilterInput) {
    onUpdateAudit(filter: $filter) {
      id
      event
      eventTime
      user {
        id
        name
        customerId
        status
        type
        lastLogin
        clientName
        updateDriverQualifications
        StandardDocuments {
          nextToken
          __typename
        }
        Audit {
          nextToken
          __typename
        }
        appAccess {
          nextToken
          __typename
        }
        cellPhone
        passwordChangeDate
        preferredMFA
        lastResetMFA
        customersAddedByAmc
        customers {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      objectName
      objectId
      objectData
      createdAt
      updatedAt
      userAuditId
      __typename
    }
  }
`;
export const onDeleteAudit = /* GraphQL */ `
  subscription OnDeleteAudit($filter: ModelSubscriptionAuditFilterInput) {
    onDeleteAudit(filter: $filter) {
      id
      event
      eventTime
      user {
        id
        name
        customerId
        status
        type
        lastLogin
        clientName
        updateDriverQualifications
        StandardDocuments {
          nextToken
          __typename
        }
        Audit {
          nextToken
          __typename
        }
        appAccess {
          nextToken
          __typename
        }
        cellPhone
        passwordChangeDate
        preferredMFA
        lastResetMFA
        customersAddedByAmc
        customers {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      objectName
      objectId
      objectData
      createdAt
      updatedAt
      userAuditId
      __typename
    }
  }
`;
export const onCreateApplication = /* GraphQL */ `
  subscription OnCreateApplication(
    $filter: ModelSubscriptionApplicationFilterInput
  ) {
    onCreateApplication(filter: $filter) {
      id
      name
      roles {
        items {
          id
          name
          usedBy
          applicationUsedBy
          viewFullPii
          createdAt
          updatedAt
          applicationRolesId
          __typename
        }
        nextToken
        __typename
      }
      userAppAccess {
        items {
          id
          createdAt
          updatedAt
          userAppAccessId
          applicationUserAppAccessId
          applicationRoleUserAppAccessId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateApplication = /* GraphQL */ `
  subscription OnUpdateApplication(
    $filter: ModelSubscriptionApplicationFilterInput
  ) {
    onUpdateApplication(filter: $filter) {
      id
      name
      roles {
        items {
          id
          name
          usedBy
          applicationUsedBy
          viewFullPii
          createdAt
          updatedAt
          applicationRolesId
          __typename
        }
        nextToken
        __typename
      }
      userAppAccess {
        items {
          id
          createdAt
          updatedAt
          userAppAccessId
          applicationUserAppAccessId
          applicationRoleUserAppAccessId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteApplication = /* GraphQL */ `
  subscription OnDeleteApplication(
    $filter: ModelSubscriptionApplicationFilterInput
  ) {
    onDeleteApplication(filter: $filter) {
      id
      name
      roles {
        items {
          id
          name
          usedBy
          applicationUsedBy
          viewFullPii
          createdAt
          updatedAt
          applicationRolesId
          __typename
        }
        nextToken
        __typename
      }
      userAppAccess {
        items {
          id
          createdAt
          updatedAt
          userAppAccessId
          applicationUserAppAccessId
          applicationRoleUserAppAccessId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateApplicationRole = /* GraphQL */ `
  subscription OnCreateApplicationRole(
    $filter: ModelSubscriptionApplicationRoleFilterInput
  ) {
    onCreateApplicationRole(filter: $filter) {
      id
      name
      usedBy
      userAppAccess {
        items {
          id
          createdAt
          updatedAt
          userAppAccessId
          applicationUserAppAccessId
          applicationRoleUserAppAccessId
          __typename
        }
        nextToken
        __typename
      }
      applicationUsedBy
      viewFullPii
      createdAt
      updatedAt
      applicationRolesId
      __typename
    }
  }
`;
export const onUpdateApplicationRole = /* GraphQL */ `
  subscription OnUpdateApplicationRole(
    $filter: ModelSubscriptionApplicationRoleFilterInput
  ) {
    onUpdateApplicationRole(filter: $filter) {
      id
      name
      usedBy
      userAppAccess {
        items {
          id
          createdAt
          updatedAt
          userAppAccessId
          applicationUserAppAccessId
          applicationRoleUserAppAccessId
          __typename
        }
        nextToken
        __typename
      }
      applicationUsedBy
      viewFullPii
      createdAt
      updatedAt
      applicationRolesId
      __typename
    }
  }
`;
export const onDeleteApplicationRole = /* GraphQL */ `
  subscription OnDeleteApplicationRole(
    $filter: ModelSubscriptionApplicationRoleFilterInput
  ) {
    onDeleteApplicationRole(filter: $filter) {
      id
      name
      usedBy
      userAppAccess {
        items {
          id
          createdAt
          updatedAt
          userAppAccessId
          applicationUserAppAccessId
          applicationRoleUserAppAccessId
          __typename
        }
        nextToken
        __typename
      }
      applicationUsedBy
      viewFullPii
      createdAt
      updatedAt
      applicationRolesId
      __typename
    }
  }
`;
export const onCreateUserApplicationAccess = /* GraphQL */ `
  subscription OnCreateUserApplicationAccess(
    $filter: ModelSubscriptionUserApplicationAccessFilterInput
  ) {
    onCreateUserApplicationAccess(filter: $filter) {
      id
      userId {
        id
        name
        customerId
        status
        type
        lastLogin
        clientName
        updateDriverQualifications
        StandardDocuments {
          nextToken
          __typename
        }
        Audit {
          nextToken
          __typename
        }
        appAccess {
          nextToken
          __typename
        }
        cellPhone
        passwordChangeDate
        preferredMFA
        lastResetMFA
        customersAddedByAmc
        customers {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      appId {
        id
        name
        roles {
          nextToken
          __typename
        }
        userAppAccess {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      roleId {
        id
        name
        usedBy
        userAppAccess {
          nextToken
          __typename
        }
        applicationUsedBy
        viewFullPii
        createdAt
        updatedAt
        applicationRolesId
        __typename
      }
      createdAt
      updatedAt
      userAppAccessId
      applicationUserAppAccessId
      applicationRoleUserAppAccessId
      __typename
    }
  }
`;
export const onUpdateUserApplicationAccess = /* GraphQL */ `
  subscription OnUpdateUserApplicationAccess(
    $filter: ModelSubscriptionUserApplicationAccessFilterInput
  ) {
    onUpdateUserApplicationAccess(filter: $filter) {
      id
      userId {
        id
        name
        customerId
        status
        type
        lastLogin
        clientName
        updateDriverQualifications
        StandardDocuments {
          nextToken
          __typename
        }
        Audit {
          nextToken
          __typename
        }
        appAccess {
          nextToken
          __typename
        }
        cellPhone
        passwordChangeDate
        preferredMFA
        lastResetMFA
        customersAddedByAmc
        customers {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      appId {
        id
        name
        roles {
          nextToken
          __typename
        }
        userAppAccess {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      roleId {
        id
        name
        usedBy
        userAppAccess {
          nextToken
          __typename
        }
        applicationUsedBy
        viewFullPii
        createdAt
        updatedAt
        applicationRolesId
        __typename
      }
      createdAt
      updatedAt
      userAppAccessId
      applicationUserAppAccessId
      applicationRoleUserAppAccessId
      __typename
    }
  }
`;
export const onDeleteUserApplicationAccess = /* GraphQL */ `
  subscription OnDeleteUserApplicationAccess(
    $filter: ModelSubscriptionUserApplicationAccessFilterInput
  ) {
    onDeleteUserApplicationAccess(filter: $filter) {
      id
      userId {
        id
        name
        customerId
        status
        type
        lastLogin
        clientName
        updateDriverQualifications
        StandardDocuments {
          nextToken
          __typename
        }
        Audit {
          nextToken
          __typename
        }
        appAccess {
          nextToken
          __typename
        }
        cellPhone
        passwordChangeDate
        preferredMFA
        lastResetMFA
        customersAddedByAmc
        customers {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      appId {
        id
        name
        roles {
          nextToken
          __typename
        }
        userAppAccess {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      roleId {
        id
        name
        usedBy
        userAppAccess {
          nextToken
          __typename
        }
        applicationUsedBy
        viewFullPii
        createdAt
        updatedAt
        applicationRolesId
        __typename
      }
      createdAt
      updatedAt
      userAppAccessId
      applicationUserAppAccessId
      applicationRoleUserAppAccessId
      __typename
    }
  }
`;
export const onCreateEvent = /* GraphQL */ `
  subscription OnCreateEvent($filter: ModelSubscriptionEventFilterInput) {
    onCreateEvent(filter: $filter) {
      id
      ApplicationId
      Event
      UserId
      ObjectId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateEvent = /* GraphQL */ `
  subscription OnUpdateEvent($filter: ModelSubscriptionEventFilterInput) {
    onUpdateEvent(filter: $filter) {
      id
      ApplicationId
      Event
      UserId
      ObjectId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteEvent = /* GraphQL */ `
  subscription OnDeleteEvent($filter: ModelSubscriptionEventFilterInput) {
    onDeleteEvent(filter: $filter) {
      id
      ApplicationId
      Event
      UserId
      ObjectId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateManual = /* GraphQL */ `
  subscription OnCreateManual($filter: ModelSubscriptionManualFilterInput) {
    onCreateManual(filter: $filter) {
      id
      portal
      title
      documentName
      originalFileName
      fileType
      fileSize
      active
      uploadedByEmail
      uploadedByFullName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateManual = /* GraphQL */ `
  subscription OnUpdateManual($filter: ModelSubscriptionManualFilterInput) {
    onUpdateManual(filter: $filter) {
      id
      portal
      title
      documentName
      originalFileName
      fileType
      fileSize
      active
      uploadedByEmail
      uploadedByFullName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteManual = /* GraphQL */ `
  subscription OnDeleteManual($filter: ModelSubscriptionManualFilterInput) {
    onDeleteManual(filter: $filter) {
      id
      portal
      title
      documentName
      originalFileName
      fileType
      fileSize
      active
      uploadedByEmail
      uploadedByFullName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDocumentSubject = /* GraphQL */ `
  subscription OnCreateDocumentSubject(
    $filter: ModelSubscriptionDocumentSubjectFilterInput
  ) {
    onCreateDocumentSubject(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDocumentSubject = /* GraphQL */ `
  subscription OnUpdateDocumentSubject(
    $filter: ModelSubscriptionDocumentSubjectFilterInput
  ) {
    onUpdateDocumentSubject(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDocumentSubject = /* GraphQL */ `
  subscription OnDeleteDocumentSubject(
    $filter: ModelSubscriptionDocumentSubjectFilterInput
  ) {
    onDeleteDocumentSubject(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDocumentSource = /* GraphQL */ `
  subscription OnCreateDocumentSource(
    $filter: ModelSubscriptionDocumentSourceFilterInput
  ) {
    onCreateDocumentSource(filter: $filter) {
      id
      name
      category {
        items {
          id
          name
          createdAt
          updatedAt
          documentSourceCategoryId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDocumentSource = /* GraphQL */ `
  subscription OnUpdateDocumentSource(
    $filter: ModelSubscriptionDocumentSourceFilterInput
  ) {
    onUpdateDocumentSource(filter: $filter) {
      id
      name
      category {
        items {
          id
          name
          createdAt
          updatedAt
          documentSourceCategoryId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDocumentSource = /* GraphQL */ `
  subscription OnDeleteDocumentSource(
    $filter: ModelSubscriptionDocumentSourceFilterInput
  ) {
    onDeleteDocumentSource(filter: $filter) {
      id
      name
      category {
        items {
          id
          name
          createdAt
          updatedAt
          documentSourceCategoryId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDocumentCategory = /* GraphQL */ `
  subscription OnCreateDocumentCategory(
    $filter: ModelSubscriptionDocumentCategoryFilterInput
  ) {
    onCreateDocumentCategory(filter: $filter) {
      id
      name
      type {
        items {
          id
          Name
          For
          createdAt
          updatedAt
          documentCategoryTypeId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      documentSourceCategoryId
      __typename
    }
  }
`;
export const onUpdateDocumentCategory = /* GraphQL */ `
  subscription OnUpdateDocumentCategory(
    $filter: ModelSubscriptionDocumentCategoryFilterInput
  ) {
    onUpdateDocumentCategory(filter: $filter) {
      id
      name
      type {
        items {
          id
          Name
          For
          createdAt
          updatedAt
          documentCategoryTypeId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      documentSourceCategoryId
      __typename
    }
  }
`;
export const onDeleteDocumentCategory = /* GraphQL */ `
  subscription OnDeleteDocumentCategory(
    $filter: ModelSubscriptionDocumentCategoryFilterInput
  ) {
    onDeleteDocumentCategory(filter: $filter) {
      id
      name
      type {
        items {
          id
          Name
          For
          createdAt
          updatedAt
          documentCategoryTypeId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      documentSourceCategoryId
      __typename
    }
  }
`;
export const onCreateDocumentType = /* GraphQL */ `
  subscription OnCreateDocumentType(
    $filter: ModelSubscriptionDocumentTypeFilterInput
  ) {
    onCreateDocumentType(filter: $filter) {
      id
      Name
      For
      createdAt
      updatedAt
      documentCategoryTypeId
      __typename
    }
  }
`;
export const onUpdateDocumentType = /* GraphQL */ `
  subscription OnUpdateDocumentType(
    $filter: ModelSubscriptionDocumentTypeFilterInput
  ) {
    onUpdateDocumentType(filter: $filter) {
      id
      Name
      For
      createdAt
      updatedAt
      documentCategoryTypeId
      __typename
    }
  }
`;
export const onDeleteDocumentType = /* GraphQL */ `
  subscription OnDeleteDocumentType(
    $filter: ModelSubscriptionDocumentTypeFilterInput
  ) {
    onDeleteDocumentType(filter: $filter) {
      id
      Name
      For
      createdAt
      updatedAt
      documentCategoryTypeId
      __typename
    }
  }
`;
export const onCreateChecklist = /* GraphQL */ `
  subscription OnCreateChecklist(
    $filter: ModelSubscriptionChecklistFilterInput
  ) {
    onCreateChecklist(filter: $filter) {
      id
      tier
      clientId
      clientName
      checklistDocumentName
      accountMasterCode
      checkListLevel
      items {
        items {
          id
          item
          source
          category
          type
          pages
          order
          createdAt
          updatedAt
          checklistItemsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateChecklist = /* GraphQL */ `
  subscription OnUpdateChecklist(
    $filter: ModelSubscriptionChecklistFilterInput
  ) {
    onUpdateChecklist(filter: $filter) {
      id
      tier
      clientId
      clientName
      checklistDocumentName
      accountMasterCode
      checkListLevel
      items {
        items {
          id
          item
          source
          category
          type
          pages
          order
          createdAt
          updatedAt
          checklistItemsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteChecklist = /* GraphQL */ `
  subscription OnDeleteChecklist(
    $filter: ModelSubscriptionChecklistFilterInput
  ) {
    onDeleteChecklist(filter: $filter) {
      id
      tier
      clientId
      clientName
      checklistDocumentName
      accountMasterCode
      checkListLevel
      items {
        items {
          id
          item
          source
          category
          type
          pages
          order
          createdAt
          updatedAt
          checklistItemsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateChecklistItems = /* GraphQL */ `
  subscription OnCreateChecklistItems(
    $filter: ModelSubscriptionChecklistItemsFilterInput
  ) {
    onCreateChecklistItems(filter: $filter) {
      id
      item
      source
      category
      type
      pages
      order
      createdAt
      updatedAt
      checklistItemsId
      __typename
    }
  }
`;
export const onUpdateChecklistItems = /* GraphQL */ `
  subscription OnUpdateChecklistItems(
    $filter: ModelSubscriptionChecklistItemsFilterInput
  ) {
    onUpdateChecklistItems(filter: $filter) {
      id
      item
      source
      category
      type
      pages
      order
      createdAt
      updatedAt
      checklistItemsId
      __typename
    }
  }
`;
export const onDeleteChecklistItems = /* GraphQL */ `
  subscription OnDeleteChecklistItems(
    $filter: ModelSubscriptionChecklistItemsFilterInput
  ) {
    onDeleteChecklistItems(filter: $filter) {
      id
      item
      source
      category
      type
      pages
      order
      createdAt
      updatedAt
      checklistItemsId
      __typename
    }
  }
`;
export const onCreateAiClientQualification = /* GraphQL */ `
  subscription OnCreateAiClientQualification(
    $filter: ModelSubscriptionAiClientQualificationFilterInput
  ) {
    onCreateAiClientQualification(filter: $filter) {
      id
      qualLevel
      clientId
      clientName
      accountMasterCode
      amcName
      category
      rulesKey
      rulesGeneratedAt
      rulesStatus
      createdAt
      documents {
        items {
          id
          documentName
          originalFileName
          uploadedByEmail
          uploadedByFullName
          createdAt
          updatedAt
          aiClientQualificationDocumentsId
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAiClientQualification = /* GraphQL */ `
  subscription OnUpdateAiClientQualification(
    $filter: ModelSubscriptionAiClientQualificationFilterInput
  ) {
    onUpdateAiClientQualification(filter: $filter) {
      id
      qualLevel
      clientId
      clientName
      accountMasterCode
      amcName
      category
      rulesKey
      rulesGeneratedAt
      rulesStatus
      createdAt
      documents {
        items {
          id
          documentName
          originalFileName
          uploadedByEmail
          uploadedByFullName
          createdAt
          updatedAt
          aiClientQualificationDocumentsId
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAiClientQualification = /* GraphQL */ `
  subscription OnDeleteAiClientQualification(
    $filter: ModelSubscriptionAiClientQualificationFilterInput
  ) {
    onDeleteAiClientQualification(filter: $filter) {
      id
      qualLevel
      clientId
      clientName
      accountMasterCode
      amcName
      category
      rulesKey
      rulesGeneratedAt
      rulesStatus
      createdAt
      documents {
        items {
          id
          documentName
          originalFileName
          uploadedByEmail
          uploadedByFullName
          createdAt
          updatedAt
          aiClientQualificationDocumentsId
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const onCreateAiClientQualificationDocument = /* GraphQL */ `
  subscription OnCreateAiClientQualificationDocument(
    $filter: ModelSubscriptionAiClientQualificationDocumentFilterInput
  ) {
    onCreateAiClientQualificationDocument(filter: $filter) {
      id
      documentName
      originalFileName
      uploadedByEmail
      uploadedByFullName
      createdAt
      updatedAt
      aiClientQualificationDocumentsId
      __typename
    }
  }
`;
export const onUpdateAiClientQualificationDocument = /* GraphQL */ `
  subscription OnUpdateAiClientQualificationDocument(
    $filter: ModelSubscriptionAiClientQualificationDocumentFilterInput
  ) {
    onUpdateAiClientQualificationDocument(filter: $filter) {
      id
      documentName
      originalFileName
      uploadedByEmail
      uploadedByFullName
      createdAt
      updatedAt
      aiClientQualificationDocumentsId
      __typename
    }
  }
`;
export const onDeleteAiClientQualificationDocument = /* GraphQL */ `
  subscription OnDeleteAiClientQualificationDocument(
    $filter: ModelSubscriptionAiClientQualificationDocumentFilterInput
  ) {
    onDeleteAiClientQualificationDocument(filter: $filter) {
      id
      documentName
      originalFileName
      uploadedByEmail
      uploadedByFullName
      createdAt
      updatedAt
      aiClientQualificationDocumentsId
      __typename
    }
  }
`;
export const onCreateAiPrompt = /* GraphQL */ `
  subscription OnCreateAiPrompt($filter: ModelSubscriptionAiPromptFilterInput) {
    onCreateAiPrompt(filter: $filter) {
      id
      promptKey
      version
      body
      active
      updatedByEmail
      updatedByFullName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAiPrompt = /* GraphQL */ `
  subscription OnUpdateAiPrompt($filter: ModelSubscriptionAiPromptFilterInput) {
    onUpdateAiPrompt(filter: $filter) {
      id
      promptKey
      version
      body
      active
      updatedByEmail
      updatedByFullName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAiPrompt = /* GraphQL */ `
  subscription OnDeleteAiPrompt($filter: ModelSubscriptionAiPromptFilterInput) {
    onDeleteAiPrompt(filter: $filter) {
      id
      promptKey
      version
      body
      active
      updatedByEmail
      updatedByFullName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDqfAudit = /* GraphQL */ `
  subscription OnCreateDqfAudit($filter: ModelSubscriptionDqfAuditFilterInput) {
    onCreateDqfAudit(filter: $filter) {
      id
      dqfId
      customerId
      status
      resultNote
      qualListAvailable
      qualListId
      promptVersion
      model
      effort
      reviewDate
      exceptions
      exceptionCount
      inputTokens
      outputTokens
      processingTimeMs
      requestId
      errorMessage
      createdBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDqfAudit = /* GraphQL */ `
  subscription OnUpdateDqfAudit($filter: ModelSubscriptionDqfAuditFilterInput) {
    onUpdateDqfAudit(filter: $filter) {
      id
      dqfId
      customerId
      status
      resultNote
      qualListAvailable
      qualListId
      promptVersion
      model
      effort
      reviewDate
      exceptions
      exceptionCount
      inputTokens
      outputTokens
      processingTimeMs
      requestId
      errorMessage
      createdBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDqfAudit = /* GraphQL */ `
  subscription OnDeleteDqfAudit($filter: ModelSubscriptionDqfAuditFilterInput) {
    onDeleteDqfAudit(filter: $filter) {
      id
      dqfId
      customerId
      status
      resultNote
      qualListAvailable
      qualListId
      promptVersion
      model
      effort
      reviewDate
      exceptions
      exceptionCount
      inputTokens
      outputTokens
      processingTimeMs
      requestId
      errorMessage
      createdBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateAirLine = /* GraphQL */ `
  subscription OnCreateAirLine($filter: ModelSubscriptionAirLineFilterInput) {
    onCreateAirLine(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAirLine = /* GraphQL */ `
  subscription OnUpdateAirLine($filter: ModelSubscriptionAirLineFilterInput) {
    onUpdateAirLine(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAirLine = /* GraphQL */ `
  subscription OnDeleteAirLine($filter: ModelSubscriptionAirLineFilterInput) {
    onDeleteAirLine(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateAirPort = /* GraphQL */ `
  subscription OnCreateAirPort($filter: ModelSubscriptionAirPortFilterInput) {
    onCreateAirPort(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAirPort = /* GraphQL */ `
  subscription OnUpdateAirPort($filter: ModelSubscriptionAirPortFilterInput) {
    onUpdateAirPort(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAirPort = /* GraphQL */ `
  subscription OnDeleteAirPort($filter: ModelSubscriptionAirPortFilterInput) {
    onDeleteAirPort(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateHotel = /* GraphQL */ `
  subscription OnCreateHotel($filter: ModelSubscriptionHotelFilterInput) {
    onCreateHotel(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateHotel = /* GraphQL */ `
  subscription OnUpdateHotel($filter: ModelSubscriptionHotelFilterInput) {
    onUpdateHotel(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteHotel = /* GraphQL */ `
  subscription OnDeleteHotel($filter: ModelSubscriptionHotelFilterInput) {
    onDeleteHotel(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCarRental = /* GraphQL */ `
  subscription OnCreateCarRental(
    $filter: ModelSubscriptionCarRentalFilterInput
  ) {
    onCreateCarRental(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateCarRental = /* GraphQL */ `
  subscription OnUpdateCarRental(
    $filter: ModelSubscriptionCarRentalFilterInput
  ) {
    onUpdateCarRental(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteCarRental = /* GraphQL */ `
  subscription OnDeleteCarRental(
    $filter: ModelSubscriptionCarRentalFilterInput
  ) {
    onDeleteCarRental(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateState = /* GraphQL */ `
  subscription OnCreateState($filter: ModelSubscriptionStateFilterInput) {
    onCreateState(filter: $filter) {
      id
      name
      city {
        items {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateState = /* GraphQL */ `
  subscription OnUpdateState($filter: ModelSubscriptionStateFilterInput) {
    onUpdateState(filter: $filter) {
      id
      name
      city {
        items {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteState = /* GraphQL */ `
  subscription OnDeleteState($filter: ModelSubscriptionStateFilterInput) {
    onDeleteState(filter: $filter) {
      id
      name
      city {
        items {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCity = /* GraphQL */ `
  subscription OnCreateCity($filter: ModelSubscriptionCityFilterInput) {
    onCreateCity(filter: $filter) {
      id
      state {
        id
        name
        city {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      status
      createdAt
      updatedAt
      stateCityId
      __typename
    }
  }
`;
export const onUpdateCity = /* GraphQL */ `
  subscription OnUpdateCity($filter: ModelSubscriptionCityFilterInput) {
    onUpdateCity(filter: $filter) {
      id
      state {
        id
        name
        city {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      status
      createdAt
      updatedAt
      stateCityId
      __typename
    }
  }
`;
export const onDeleteCity = /* GraphQL */ `
  subscription OnDeleteCity($filter: ModelSubscriptionCityFilterInput) {
    onDeleteCity(filter: $filter) {
      id
      state {
        id
        name
        city {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      status
      createdAt
      updatedAt
      stateCityId
      __typename
    }
  }
`;
export const onCreateExpense = /* GraphQL */ `
  subscription OnCreateExpense($filter: ModelSubscriptionExpenseFilterInput) {
    onCreateExpense(filter: $filter) {
      id
      code
      driverId
      driverName
      assignmentId
      status
      nonBillable
      customerId
      customerName
      branch
      branchName
      costCenter
      startDate
      endDate
      totalToBeBilled
      notes
      auditKey
      invoiceDate
      invoiceNumber
      invoicePaid
      amountBilled
      variance
      statementDate
      expenseReportAppropriationNbr
      expenseItem {
        items {
          id
          flightDate
          paidThrough
          creditCardHolderName
          receiptAmount
          markup
          expenseTotal
          documentName
          documentSize
          uploadedByName
          uploadedDate
          hotelConfirmationNumber
          hotelPhoneNumber
          hotelStreetAddress
          checkInDate
          lastNightOfStay
          dailyCharge
          totalReceiptAmount
          carRentalContractNumber
          carRentalPickUpLocation
          carRentalReturnLocation
          carRentalPickUpDate
          carRentalReturnDate
          originalReceiptAmount
          otherExpenseName
          otherExpenseDescription
          otherExpenseDate
          hotelDriverId
          hotelDriverName
          hotelAssignmentId
          projectedDays
          projectedAmount
          createdAt
          updatedAt
          expenseExpenseItemId
          expenseItemAirLineId
          expenseItemDepartureAirPortId
          expenseItemArrivalAirPortId
          expenseItemHotelId
          expenseItemHotelStateId
          expenseItemHotelCityId
          expenseItemCarRentalCompanyId
          __typename
        }
        nextToken
        __typename
      }
      sharedInvoice
      createdAt
      hotel {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      hotelConfirmationNumber
      hotelPhoneNumber
      hotelStreetAddress
      hotelState {
        id
        name
        city {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      hotelCity {
        id
        state {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        name
        status
        createdAt
        updatedAt
        stateCityId
        __typename
      }
      documentName
      documentSize
      uploadedByName
      uploadedDate
      totalReceiptAmount
      totalProjectedAmount
      checkedForUltraStaff
      inv
      payType
      payAmt
      billUnits
      ok
      payWeekEnding
      originalExpenseId
      correctionExpenseId
      rebilledExpenseId
      flatFeeBilling
      lob
      confirmedBy
      updatedBy
      updatedAt
      __typename
    }
  }
`;
export const onUpdateExpense = /* GraphQL */ `
  subscription OnUpdateExpense($filter: ModelSubscriptionExpenseFilterInput) {
    onUpdateExpense(filter: $filter) {
      id
      code
      driverId
      driverName
      assignmentId
      status
      nonBillable
      customerId
      customerName
      branch
      branchName
      costCenter
      startDate
      endDate
      totalToBeBilled
      notes
      auditKey
      invoiceDate
      invoiceNumber
      invoicePaid
      amountBilled
      variance
      statementDate
      expenseReportAppropriationNbr
      expenseItem {
        items {
          id
          flightDate
          paidThrough
          creditCardHolderName
          receiptAmount
          markup
          expenseTotal
          documentName
          documentSize
          uploadedByName
          uploadedDate
          hotelConfirmationNumber
          hotelPhoneNumber
          hotelStreetAddress
          checkInDate
          lastNightOfStay
          dailyCharge
          totalReceiptAmount
          carRentalContractNumber
          carRentalPickUpLocation
          carRentalReturnLocation
          carRentalPickUpDate
          carRentalReturnDate
          originalReceiptAmount
          otherExpenseName
          otherExpenseDescription
          otherExpenseDate
          hotelDriverId
          hotelDriverName
          hotelAssignmentId
          projectedDays
          projectedAmount
          createdAt
          updatedAt
          expenseExpenseItemId
          expenseItemAirLineId
          expenseItemDepartureAirPortId
          expenseItemArrivalAirPortId
          expenseItemHotelId
          expenseItemHotelStateId
          expenseItemHotelCityId
          expenseItemCarRentalCompanyId
          __typename
        }
        nextToken
        __typename
      }
      sharedInvoice
      createdAt
      hotel {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      hotelConfirmationNumber
      hotelPhoneNumber
      hotelStreetAddress
      hotelState {
        id
        name
        city {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      hotelCity {
        id
        state {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        name
        status
        createdAt
        updatedAt
        stateCityId
        __typename
      }
      documentName
      documentSize
      uploadedByName
      uploadedDate
      totalReceiptAmount
      totalProjectedAmount
      checkedForUltraStaff
      inv
      payType
      payAmt
      billUnits
      ok
      payWeekEnding
      originalExpenseId
      correctionExpenseId
      rebilledExpenseId
      flatFeeBilling
      lob
      confirmedBy
      updatedBy
      updatedAt
      __typename
    }
  }
`;
export const onDeleteExpense = /* GraphQL */ `
  subscription OnDeleteExpense($filter: ModelSubscriptionExpenseFilterInput) {
    onDeleteExpense(filter: $filter) {
      id
      code
      driverId
      driverName
      assignmentId
      status
      nonBillable
      customerId
      customerName
      branch
      branchName
      costCenter
      startDate
      endDate
      totalToBeBilled
      notes
      auditKey
      invoiceDate
      invoiceNumber
      invoicePaid
      amountBilled
      variance
      statementDate
      expenseReportAppropriationNbr
      expenseItem {
        items {
          id
          flightDate
          paidThrough
          creditCardHolderName
          receiptAmount
          markup
          expenseTotal
          documentName
          documentSize
          uploadedByName
          uploadedDate
          hotelConfirmationNumber
          hotelPhoneNumber
          hotelStreetAddress
          checkInDate
          lastNightOfStay
          dailyCharge
          totalReceiptAmount
          carRentalContractNumber
          carRentalPickUpLocation
          carRentalReturnLocation
          carRentalPickUpDate
          carRentalReturnDate
          originalReceiptAmount
          otherExpenseName
          otherExpenseDescription
          otherExpenseDate
          hotelDriverId
          hotelDriverName
          hotelAssignmentId
          projectedDays
          projectedAmount
          createdAt
          updatedAt
          expenseExpenseItemId
          expenseItemAirLineId
          expenseItemDepartureAirPortId
          expenseItemArrivalAirPortId
          expenseItemHotelId
          expenseItemHotelStateId
          expenseItemHotelCityId
          expenseItemCarRentalCompanyId
          __typename
        }
        nextToken
        __typename
      }
      sharedInvoice
      createdAt
      hotel {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      hotelConfirmationNumber
      hotelPhoneNumber
      hotelStreetAddress
      hotelState {
        id
        name
        city {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      hotelCity {
        id
        state {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        name
        status
        createdAt
        updatedAt
        stateCityId
        __typename
      }
      documentName
      documentSize
      uploadedByName
      uploadedDate
      totalReceiptAmount
      totalProjectedAmount
      checkedForUltraStaff
      inv
      payType
      payAmt
      billUnits
      ok
      payWeekEnding
      originalExpenseId
      correctionExpenseId
      rebilledExpenseId
      flatFeeBilling
      lob
      confirmedBy
      updatedBy
      updatedAt
      __typename
    }
  }
`;
export const onCreateExpenseItem = /* GraphQL */ `
  subscription OnCreateExpenseItem(
    $filter: ModelSubscriptionExpenseItemFilterInput
  ) {
    onCreateExpenseItem(filter: $filter) {
      id
      expense {
        id
        code
        driverId
        driverName
        assignmentId
        status
        nonBillable
        customerId
        customerName
        branch
        branchName
        costCenter
        startDate
        endDate
        totalToBeBilled
        notes
        auditKey
        invoiceDate
        invoiceNumber
        invoicePaid
        amountBilled
        variance
        statementDate
        expenseReportAppropriationNbr
        expenseItem {
          nextToken
          __typename
        }
        sharedInvoice
        createdAt
        hotel {
          id
          name
          status
          createdAt
          updatedAt
          __typename
        }
        hotelConfirmationNumber
        hotelPhoneNumber
        hotelStreetAddress
        hotelState {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        hotelCity {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        documentName
        documentSize
        uploadedByName
        uploadedDate
        totalReceiptAmount
        totalProjectedAmount
        checkedForUltraStaff
        inv
        payType
        payAmt
        billUnits
        ok
        payWeekEnding
        originalExpenseId
        correctionExpenseId
        rebilledExpenseId
        flatFeeBilling
        lob
        confirmedBy
        updatedBy
        updatedAt
        __typename
      }
      airLine {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      departureAirPort {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      arrivalAirPort {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      flightDate
      paidThrough
      creditCardHolderName
      receiptAmount
      markup
      expenseTotal
      documentName
      documentSize
      uploadedByName
      uploadedDate
      hotel {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      hotelConfirmationNumber
      hotelPhoneNumber
      hotelStreetAddress
      hotelState {
        id
        name
        city {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      hotelCity {
        id
        state {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        name
        status
        createdAt
        updatedAt
        stateCityId
        __typename
      }
      checkInDate
      lastNightOfStay
      dailyCharge
      totalReceiptAmount
      carRentalCompany {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      carRentalContractNumber
      carRentalPickUpLocation
      carRentalReturnLocation
      carRentalPickUpDate
      carRentalReturnDate
      originalReceiptAmount
      otherExpenseName
      otherExpenseDescription
      otherExpenseDate
      hotelDriverId
      hotelDriverName
      hotelAssignmentId
      projectedDays
      projectedAmount
      createdAt
      updatedAt
      expenseExpenseItemId
      expenseItemAirLineId
      expenseItemDepartureAirPortId
      expenseItemArrivalAirPortId
      expenseItemHotelId
      expenseItemHotelStateId
      expenseItemHotelCityId
      expenseItemCarRentalCompanyId
      __typename
    }
  }
`;
export const onUpdateExpenseItem = /* GraphQL */ `
  subscription OnUpdateExpenseItem(
    $filter: ModelSubscriptionExpenseItemFilterInput
  ) {
    onUpdateExpenseItem(filter: $filter) {
      id
      expense {
        id
        code
        driverId
        driverName
        assignmentId
        status
        nonBillable
        customerId
        customerName
        branch
        branchName
        costCenter
        startDate
        endDate
        totalToBeBilled
        notes
        auditKey
        invoiceDate
        invoiceNumber
        invoicePaid
        amountBilled
        variance
        statementDate
        expenseReportAppropriationNbr
        expenseItem {
          nextToken
          __typename
        }
        sharedInvoice
        createdAt
        hotel {
          id
          name
          status
          createdAt
          updatedAt
          __typename
        }
        hotelConfirmationNumber
        hotelPhoneNumber
        hotelStreetAddress
        hotelState {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        hotelCity {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        documentName
        documentSize
        uploadedByName
        uploadedDate
        totalReceiptAmount
        totalProjectedAmount
        checkedForUltraStaff
        inv
        payType
        payAmt
        billUnits
        ok
        payWeekEnding
        originalExpenseId
        correctionExpenseId
        rebilledExpenseId
        flatFeeBilling
        lob
        confirmedBy
        updatedBy
        updatedAt
        __typename
      }
      airLine {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      departureAirPort {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      arrivalAirPort {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      flightDate
      paidThrough
      creditCardHolderName
      receiptAmount
      markup
      expenseTotal
      documentName
      documentSize
      uploadedByName
      uploadedDate
      hotel {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      hotelConfirmationNumber
      hotelPhoneNumber
      hotelStreetAddress
      hotelState {
        id
        name
        city {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      hotelCity {
        id
        state {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        name
        status
        createdAt
        updatedAt
        stateCityId
        __typename
      }
      checkInDate
      lastNightOfStay
      dailyCharge
      totalReceiptAmount
      carRentalCompany {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      carRentalContractNumber
      carRentalPickUpLocation
      carRentalReturnLocation
      carRentalPickUpDate
      carRentalReturnDate
      originalReceiptAmount
      otherExpenseName
      otherExpenseDescription
      otherExpenseDate
      hotelDriverId
      hotelDriverName
      hotelAssignmentId
      projectedDays
      projectedAmount
      createdAt
      updatedAt
      expenseExpenseItemId
      expenseItemAirLineId
      expenseItemDepartureAirPortId
      expenseItemArrivalAirPortId
      expenseItemHotelId
      expenseItemHotelStateId
      expenseItemHotelCityId
      expenseItemCarRentalCompanyId
      __typename
    }
  }
`;
export const onDeleteExpenseItem = /* GraphQL */ `
  subscription OnDeleteExpenseItem(
    $filter: ModelSubscriptionExpenseItemFilterInput
  ) {
    onDeleteExpenseItem(filter: $filter) {
      id
      expense {
        id
        code
        driverId
        driverName
        assignmentId
        status
        nonBillable
        customerId
        customerName
        branch
        branchName
        costCenter
        startDate
        endDate
        totalToBeBilled
        notes
        auditKey
        invoiceDate
        invoiceNumber
        invoicePaid
        amountBilled
        variance
        statementDate
        expenseReportAppropriationNbr
        expenseItem {
          nextToken
          __typename
        }
        sharedInvoice
        createdAt
        hotel {
          id
          name
          status
          createdAt
          updatedAt
          __typename
        }
        hotelConfirmationNumber
        hotelPhoneNumber
        hotelStreetAddress
        hotelState {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        hotelCity {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        documentName
        documentSize
        uploadedByName
        uploadedDate
        totalReceiptAmount
        totalProjectedAmount
        checkedForUltraStaff
        inv
        payType
        payAmt
        billUnits
        ok
        payWeekEnding
        originalExpenseId
        correctionExpenseId
        rebilledExpenseId
        flatFeeBilling
        lob
        confirmedBy
        updatedBy
        updatedAt
        __typename
      }
      airLine {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      departureAirPort {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      arrivalAirPort {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      flightDate
      paidThrough
      creditCardHolderName
      receiptAmount
      markup
      expenseTotal
      documentName
      documentSize
      uploadedByName
      uploadedDate
      hotel {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      hotelConfirmationNumber
      hotelPhoneNumber
      hotelStreetAddress
      hotelState {
        id
        name
        city {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      hotelCity {
        id
        state {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        name
        status
        createdAt
        updatedAt
        stateCityId
        __typename
      }
      checkInDate
      lastNightOfStay
      dailyCharge
      totalReceiptAmount
      carRentalCompany {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      carRentalContractNumber
      carRentalPickUpLocation
      carRentalReturnLocation
      carRentalPickUpDate
      carRentalReturnDate
      originalReceiptAmount
      otherExpenseName
      otherExpenseDescription
      otherExpenseDate
      hotelDriverId
      hotelDriverName
      hotelAssignmentId
      projectedDays
      projectedAmount
      createdAt
      updatedAt
      expenseExpenseItemId
      expenseItemAirLineId
      expenseItemDepartureAirPortId
      expenseItemArrivalAirPortId
      expenseItemHotelId
      expenseItemHotelStateId
      expenseItemHotelCityId
      expenseItemCarRentalCompanyId
      __typename
    }
  }
`;
export const onCreateTATQuiz = /* GraphQL */ `
  subscription OnCreateTATQuiz($filter: ModelSubscriptionTATQuizFilterInput) {
    onCreateTATQuiz(filter: $filter) {
      id
      livesOfPotentialVictims
      isTraffickingInTheUntiedStates
      whereTraffickingHappen
      victimsNeedAidInTheirRecovery
      humanTraffickingIsExploitation
      traffickersGroomPotentialVictims
      vulnerabilityFactors
      minorsSellingSexIsProstitution
      redFlagsToWatchOutFor
      crimesInProgress
      certificate
      status
      attempts
      employeeFullName
      emailNotificationStatus
      emailNotificationDateTime
      firstName
      lastName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateTATQuiz = /* GraphQL */ `
  subscription OnUpdateTATQuiz($filter: ModelSubscriptionTATQuizFilterInput) {
    onUpdateTATQuiz(filter: $filter) {
      id
      livesOfPotentialVictims
      isTraffickingInTheUntiedStates
      whereTraffickingHappen
      victimsNeedAidInTheirRecovery
      humanTraffickingIsExploitation
      traffickersGroomPotentialVictims
      vulnerabilityFactors
      minorsSellingSexIsProstitution
      redFlagsToWatchOutFor
      crimesInProgress
      certificate
      status
      attempts
      employeeFullName
      emailNotificationStatus
      emailNotificationDateTime
      firstName
      lastName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteTATQuiz = /* GraphQL */ `
  subscription OnDeleteTATQuiz($filter: ModelSubscriptionTATQuizFilterInput) {
    onDeleteTATQuiz(filter: $filter) {
      id
      livesOfPotentialVictims
      isTraffickingInTheUntiedStates
      whereTraffickingHappen
      victimsNeedAidInTheirRecovery
      humanTraffickingIsExploitation
      traffickersGroomPotentialVictims
      vulnerabilityFactors
      minorsSellingSexIsProstitution
      redFlagsToWatchOutFor
      crimesInProgress
      certificate
      status
      attempts
      employeeFullName
      emailNotificationStatus
      emailNotificationDateTime
      firstName
      lastName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreatePushNotification = /* GraphQL */ `
  subscription OnCreatePushNotification(
    $filter: ModelSubscriptionPushNotificationFilterInput
  ) {
    onCreatePushNotification(filter: $filter) {
      id
      type
      subject
      message
      url
      status
      lob
      branch
      recipientStatus
      approvedBy
      approvedAt
      sentOn
      createdAt
      createdBy
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePushNotification = /* GraphQL */ `
  subscription OnUpdatePushNotification(
    $filter: ModelSubscriptionPushNotificationFilterInput
  ) {
    onUpdatePushNotification(filter: $filter) {
      id
      type
      subject
      message
      url
      status
      lob
      branch
      recipientStatus
      approvedBy
      approvedAt
      sentOn
      createdAt
      createdBy
      updatedAt
      __typename
    }
  }
`;
export const onDeletePushNotification = /* GraphQL */ `
  subscription OnDeletePushNotification(
    $filter: ModelSubscriptionPushNotificationFilterInput
  ) {
    onDeletePushNotification(filter: $filter) {
      id
      type
      subject
      message
      url
      status
      lob
      branch
      recipientStatus
      approvedBy
      approvedAt
      sentOn
      createdAt
      createdBy
      updatedAt
      __typename
    }
  }
`;
export const onCreateBenefitClassCode = /* GraphQL */ `
  subscription OnCreateBenefitClassCode(
    $filter: ModelSubscriptionBenefitClassCodeFilterInput
  ) {
    onCreateBenefitClassCode(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateBenefitClassCode = /* GraphQL */ `
  subscription OnUpdateBenefitClassCode(
    $filter: ModelSubscriptionBenefitClassCodeFilterInput
  ) {
    onUpdateBenefitClassCode(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteBenefitClassCode = /* GraphQL */ `
  subscription OnDeleteBenefitClassCode(
    $filter: ModelSubscriptionBenefitClassCodeFilterInput
  ) {
    onDeleteBenefitClassCode(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateBenefitDivisionCode = /* GraphQL */ `
  subscription OnCreateBenefitDivisionCode(
    $filter: ModelSubscriptionBenefitDivisionCodeFilterInput
  ) {
    onCreateBenefitDivisionCode(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateBenefitDivisionCode = /* GraphQL */ `
  subscription OnUpdateBenefitDivisionCode(
    $filter: ModelSubscriptionBenefitDivisionCodeFilterInput
  ) {
    onUpdateBenefitDivisionCode(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteBenefitDivisionCode = /* GraphQL */ `
  subscription OnDeleteBenefitDivisionCode(
    $filter: ModelSubscriptionBenefitDivisionCodeFilterInput
  ) {
    onDeleteBenefitDivisionCode(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateBenefitPlanType = /* GraphQL */ `
  subscription OnCreateBenefitPlanType(
    $filter: ModelSubscriptionBenefitPlanTypeFilterInput
  ) {
    onCreateBenefitPlanType(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateBenefitPlanType = /* GraphQL */ `
  subscription OnUpdateBenefitPlanType(
    $filter: ModelSubscriptionBenefitPlanTypeFilterInput
  ) {
    onUpdateBenefitPlanType(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteBenefitPlanType = /* GraphQL */ `
  subscription OnDeleteBenefitPlanType(
    $filter: ModelSubscriptionBenefitPlanTypeFilterInput
  ) {
    onDeleteBenefitPlanType(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateBenefitTypeOfCoverage = /* GraphQL */ `
  subscription OnCreateBenefitTypeOfCoverage(
    $filter: ModelSubscriptionBenefitTypeOfCoverageFilterInput
  ) {
    onCreateBenefitTypeOfCoverage(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateBenefitTypeOfCoverage = /* GraphQL */ `
  subscription OnUpdateBenefitTypeOfCoverage(
    $filter: ModelSubscriptionBenefitTypeOfCoverageFilterInput
  ) {
    onUpdateBenefitTypeOfCoverage(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteBenefitTypeOfCoverage = /* GraphQL */ `
  subscription OnDeleteBenefitTypeOfCoverage(
    $filter: ModelSubscriptionBenefitTypeOfCoverageFilterInput
  ) {
    onDeleteBenefitTypeOfCoverage(filter: $filter) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDmsDriver = /* GraphQL */ `
  subscription OnCreateDmsDriver(
    $filter: ModelSubscriptionDmsDriverFilterInput
  ) {
    onCreateDmsDriver(filter: $filter) {
      id
      driverId
      firstName
      lastName
      lob
      currentClientId
      currentClientName
      latestActivityEndDate
      serviceAction
      benefitsAction
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDmsDriver = /* GraphQL */ `
  subscription OnUpdateDmsDriver(
    $filter: ModelSubscriptionDmsDriverFilterInput
  ) {
    onUpdateDmsDriver(filter: $filter) {
      id
      driverId
      firstName
      lastName
      lob
      currentClientId
      currentClientName
      latestActivityEndDate
      serviceAction
      benefitsAction
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDmsDriver = /* GraphQL */ `
  subscription OnDeleteDmsDriver(
    $filter: ModelSubscriptionDmsDriverFilterInput
  ) {
    onDeleteDmsDriver(filter: $filter) {
      id
      driverId
      firstName
      lastName
      lob
      currentClientId
      currentClientName
      latestActivityEndDate
      serviceAction
      benefitsAction
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDmsContractActivity = /* GraphQL */ `
  subscription OnCreateDmsContractActivity(
    $filter: ModelSubscriptionDmsContractActivityFilterInput
  ) {
    onCreateDmsContractActivity(filter: $filter) {
      id
      driverId
      driverName
      lob
      branch
      recruiterRpc
      enteredDate
      contractStartDate
      contractEndDate
      jobOrderId
      clientId
      clientName
      portalStatus
      forPayroll
      clearServiceActionFlag
      clearBenefitActionFlag
      payRate
      payRateUnit
      payType
      salaryAmount
      fullOrPartTime
      benefitsElection
      notes
      benefitEffectiveDate
      benefitTerminationDate
      benefitTimeStatus
      medPolicy
      typeOfCoverage
      planType
      benefitClassCode
      benefitDivisionCode
      billingCycle
      billingAmount
      medicalContractActivityId
      medicalJobOrderId
      medicalContractStartDate
      medicalContractEndDate
      medicalFillDate
      medicalFillPc
      startBenSentDate
      termBenSentDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDmsContractActivity = /* GraphQL */ `
  subscription OnUpdateDmsContractActivity(
    $filter: ModelSubscriptionDmsContractActivityFilterInput
  ) {
    onUpdateDmsContractActivity(filter: $filter) {
      id
      driverId
      driverName
      lob
      branch
      recruiterRpc
      enteredDate
      contractStartDate
      contractEndDate
      jobOrderId
      clientId
      clientName
      portalStatus
      forPayroll
      clearServiceActionFlag
      clearBenefitActionFlag
      payRate
      payRateUnit
      payType
      salaryAmount
      fullOrPartTime
      benefitsElection
      notes
      benefitEffectiveDate
      benefitTerminationDate
      benefitTimeStatus
      medPolicy
      typeOfCoverage
      planType
      benefitClassCode
      benefitDivisionCode
      billingCycle
      billingAmount
      medicalContractActivityId
      medicalJobOrderId
      medicalContractStartDate
      medicalContractEndDate
      medicalFillDate
      medicalFillPc
      startBenSentDate
      termBenSentDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDmsContractActivity = /* GraphQL */ `
  subscription OnDeleteDmsContractActivity(
    $filter: ModelSubscriptionDmsContractActivityFilterInput
  ) {
    onDeleteDmsContractActivity(filter: $filter) {
      id
      driverId
      driverName
      lob
      branch
      recruiterRpc
      enteredDate
      contractStartDate
      contractEndDate
      jobOrderId
      clientId
      clientName
      portalStatus
      forPayroll
      clearServiceActionFlag
      clearBenefitActionFlag
      payRate
      payRateUnit
      payType
      salaryAmount
      fullOrPartTime
      benefitsElection
      notes
      benefitEffectiveDate
      benefitTerminationDate
      benefitTimeStatus
      medPolicy
      typeOfCoverage
      planType
      benefitClassCode
      benefitDivisionCode
      billingCycle
      billingAmount
      medicalContractActivityId
      medicalJobOrderId
      medicalContractStartDate
      medicalContractEndDate
      medicalFillDate
      medicalFillPc
      startBenSentDate
      termBenSentDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateTimeOffRequest = /* GraphQL */ `
  subscription OnCreateTimeOffRequest(
    $filter: ModelSubscriptionTimeOffRequestFilterInput
  ) {
    onCreateTimeOffRequest(filter: $filter) {
      id
      employeeId
      employeeName
      customerId
      customerName
      startDate
      endDate
      reason
      employeeComment
      serviceComment
      status
      approvedByUserId
      approvedByUserName
      cancelledByUserId
      cancelledByUserName
      declinedByUserId
      declinedByUserName
      resetByUserId
      resetByUserName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateTimeOffRequest = /* GraphQL */ `
  subscription OnUpdateTimeOffRequest(
    $filter: ModelSubscriptionTimeOffRequestFilterInput
  ) {
    onUpdateTimeOffRequest(filter: $filter) {
      id
      employeeId
      employeeName
      customerId
      customerName
      startDate
      endDate
      reason
      employeeComment
      serviceComment
      status
      approvedByUserId
      approvedByUserName
      cancelledByUserId
      cancelledByUserName
      declinedByUserId
      declinedByUserName
      resetByUserId
      resetByUserName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteTimeOffRequest = /* GraphQL */ `
  subscription OnDeleteTimeOffRequest(
    $filter: ModelSubscriptionTimeOffRequestFilterInput
  ) {
    onDeleteTimeOffRequest(filter: $filter) {
      id
      employeeId
      employeeName
      customerId
      customerName
      startDate
      endDate
      reason
      employeeComment
      serviceComment
      status
      approvedByUserId
      approvedByUserName
      cancelledByUserId
      cancelledByUserName
      declinedByUserId
      declinedByUserName
      resetByUserId
      resetByUserName
      createdAt
      updatedAt
      __typename
    }
  }
`;
